import Guard from '@/services/middleware'
// const DashLayout = () => import('@/layouts/DashLayout.vue')
const General = () => import('@/views/dash/settings/configurations/General.vue')
const OpeningHours = () => import('@/views/dash/settings/configurations/OpeningHours.vue')
const GroupSla = () => import('@/views/dash/settings/configurations/GroupSla.vue')
const AttendanceConfirmation = () => import('@/views/dash/settings/configurations/AttendanceConfirmation.vue')

export default [
    {
        path: 'gerais',
        name: 'configurations.general',
        meta: { title: 'Configurações gerais', permission: 2, module: 'config_system' },
        component: General,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],

    },
    {
        path: 'horario-de-funcionamento',
        name: 'configurations.hours',
        meta: { title: 'Horário de Funcionamento', permission: 2, module: 'config_system' },
        component: OpeningHours,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
    {
        path: 'confirmacao-novo-atendimento',
        name: 'configurations.attendance_confirmation',
        meta: { title: 'Confirmação de novo atendimento', permission: 2, module: 'config_system' },
        component: AttendanceConfirmation,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
    {
        path: 'sla',
        name: 'configurations.sla',
        meta: { title: 'SLA', permission: 2, module: 'config_system' },
        component: GroupSla,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],

    },
]